import PropTypes from'prop-types';export default PropTypes.shape({type_access_id:PropTypes.number,contract:PropTypes.shape({id:PropTypes.number})});